// Physical products (phase 9): quantity stepper on the product page and "add to cart" buttons
// ([data-product-add="id"], optional data-qty-source selector + data-max) through the REST cart (cart.js).
import { qs, on } from './dom.js';
import { addItems, getCart } from './cart.js';

function stepper(btn, delta) {
  const wrap = btn.closest('[data-stepper]');
  const out = wrap && qs('[data-qty-value]', wrap);
  if (!out) return;
  const page = btn.closest('[data-product-page]') || document;
  const add = qs('[data-product-add]', page);
  const max = Math.max(1, Number((add && add.dataset.max) || 10));
  const next = Math.min(max, Math.max(1, Number(out.textContent || 1) + delta));
  out.textContent = String(next);
  const minus = qs('[data-qty-minus]', wrap);
  const plus = qs('[data-qty-plus]', wrap);
  if (minus) minus.disabled = next <= 1;
  if (plus) plus.disabled = next >= max;
}

export function initShop() {
  on(document, 'click', '[data-product-page] [data-qty-minus]', (e, btn) => { e.preventDefault(); stepper(btn, -1); });
  on(document, 'click', '[data-product-page] [data-qty-plus]', (e, btn) => { e.preventDefault(); stepper(btn, 1); });
  on(document, 'click', '[data-product-add]', async (e, btn) => {
    e.preventDefault();
    const id = Number(btn.dataset.productAdd);
    if (!id) return;
    let qty = 1;
    if (btn.dataset.qtySource) {
      const src = qs(btn.dataset.qtySource, btn.closest('[data-product-page]') || document);
      qty = Math.max(1, Number((src && (src.value || src.textContent)) || 1));
    }
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    try {
      const before = getCart();
      const r = await addItems({ product_id: id, qty });
      // analytics (1.9.0): value = cart total difference (no prices are computed in JS)
      if (r) window.ktTrack?.('add_to_cart', before ? Math.max(0, Math.round((Number(r.total) - Number(before.total)) * 100) / 100) : Number(r.total) || 0);
    } finally {
      btn.disabled = false;
      btn.removeAttribute('aria-busy');
    }
  });
}
